export enum PersonRelationshipType {
    Employee = 'Employee',
    Contractor = 'Contractor',
    JvPartner = 'JV Partner',
}